/**
 * Paleta pastel para íconos — derivada del Design System v1.2.
 * Cada tono define { bg, fg } para badges y contenedores de íconos.
 */
export const pastel = {
  violet: { bg: '#EEEAFE', fg: '#5346E6', soft: '#F6F4FF' },
  sky: { bg: '#DCE7FF', fg: '#2F6BFF', soft: '#EEF4FF' },
  indigo: { bg: '#E0E4FA', fg: '#4C53C7', soft: '#F1F3FC' },
  teal: { bg: '#D6F3F3', fg: '#00A6A6', soft: '#EAFAFA' },
  mint: { bg: '#DFF6EC', fg: '#1E9F73', soft: '#EEFAF4' },
  amber: { bg: '#FFF1D6', fg: '#C98718', soft: '#FFF9EC' },
  coral: { bg: '#FFE0DA', fg: '#E25E48', soft: '#FFF1ED' },
  pink: { bg: '#FCE4EF', fg: '#D24B8A', soft: '#FEF1F6' },
};

export const toneOrder = ['violet', 'sky', 'amber', 'mint', 'coral', 'indigo', 'teal', 'pink'];
